import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { KeyCodes } from 'advenio-components'

const Overlay = styled.div`
  background-color: rgba(0,0,0,1);
  height: 100%;
  width: 100%;
  display: ${props => props.open ? 'flex' : 'none'};
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 99999;
  top:0;
  left: 0;
`

const Img = styled.img`
  width: 95%;
  @media (min-width:768px) {
    width: 600px;
  }
`
const CloseMark = styled.div`
  background-image: url(/assets/Close.svg);
  background-size: cover;
  height: 24px;
  width: 24px;
  position: absolute;
  right: 16px;
  top: 16px;
  cursor: pointer;
`

class ImageViewer extends Component {
  componentWillReceiveProps = ({ open }) => {
    if (open) {
      document.querySelector('body').style.height = '400px'
      document.querySelector('body').style.overflow = 'hidden'
      document.querySelector('#root').style.height = '400px'
      document.querySelector('#root').style.overflow = 'hidden'
    } else {
      document.querySelector('body').style.height = 'auto'
      document.querySelector('body').style.overflow = 'auto'
      document.querySelector('#root').style.height = 'auto'
      document.querySelector('#root').style.overflow = 'auto'
    }
  }

  componentDidUpdate = () => {
    const { open } = this.props
    if (open) {
      this.overlay.focus()
    }
  }

  componentWillUnmount = () => {
    document.querySelector('body').style.height = 'auto'
    document.querySelector('body').style.overflow = 'auto'
    document.querySelector('#root').style.height = 'auto'
    document.querySelector('#root').style.overflow = 'auto'
  }

  handleOnKeyDown = e => e.which === KeyCodes.ESC && this.props.onClose()

  render() {
    const { onClose, img, open } = this.props
    return (
      <Overlay
        open={open}
        onClick={onClose}
        onKeyDown={e => this.handleOnKeyDown(e)}
        tabIndex="0"
        innerRef={(overlay) => { this.overlay = overlay}}
      >
        <CloseMark onClick={onClose} />
        <Img
          onClick={e => e.stopPropagation()}
          src={img}
          alt="image"
        />
      </Overlay>
    )
  }
}

ImageViewer.propTypes = {
  img: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool,
}

ImageViewer.defaultProps = {
  img: '',
  onClose: undefined,
  open: false,
}
export default ImageViewer



// WEBPACK FOOTER //
// ./src/Components/ParentPlatform/ImageViewer/index.jsx